import {
  ALL_USERS_FLOWCODE_COLOR_OPTIONS,
  FREE_LOGGED_IN_FLOWCODE_COLOR_OPTIONS,
  PRO_ENTERPRISE_FLOWCODE_COLOR_OPTIONS
} from '../constants/flowcode'
import { FlowcodeColorOptionType } from '../types/flowcode.types'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useMemo } from 'react'

export interface UseGatedBuilderColorsReturnType {
  availableColors: FlowcodeColorOptionType[]
  gatedColors: FlowcodeColorOptionType[]
}

const allColorsSorted = [
  ...ALL_USERS_FLOWCODE_COLOR_OPTIONS,
  ...FREE_LOGGED_IN_FLOWCODE_COLOR_OPTIONS,
  ...PRO_ENTERPRISE_FLOWCODE_COLOR_OPTIONS
].sort((c1, c2) => c1.index - c2.index)

const freeLoggedInColorsSorted = [
  ...ALL_USERS_FLOWCODE_COLOR_OPTIONS,
  ...FREE_LOGGED_IN_FLOWCODE_COLOR_OPTIONS
].sort((c1, c2) => c1.index - c2.index)

export function useGatedBuilderColors(): UseGatedBuilderColorsReturnType {
  const { isAuthenticated, hasOperation } = useAuthState()

  const availableColors = useMemo(() => {
    if (hasOperation('view:all_code_colors')) {
      return allColorsSorted
    } else if (isAuthenticated) {
      return freeLoggedInColorsSorted
    } else {
      return ALL_USERS_FLOWCODE_COLOR_OPTIONS
    }
  }, [isAuthenticated, hasOperation])

  const gatedColors = useMemo(() => {
    return allColorsSorted.filter(c => !availableColors.includes(c))
  }, [availableColors])

  return {
    availableColors,
    gatedColors
  }
}
